var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Breadcrumbs"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('nav',{staticClass:"menubar"},[_c('router-link',{staticClass:"breadcrumb",attrs:{"to":"/"}},[_c('v-icon',[_vm._v("dashboard")]),_vm._v(" Dashboard ")],1),_c('span',{staticClass:"breadcrumb"},[_vm._v(" "+_vm._s(_vm.breadcrumbs.page))])],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }